var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E40080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7476_65335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2125 8.93607L15.6322 7.77818C15.6322 7.77818 14.3267 6.82306 14.3286 6.82495C13.7092 6.36729 12.8414 6.4971 12.3764 6.60323L7.25244 7.80187C6.5609 7.9639 6 8.69161 6 9.4269V14.6204C6 15.3557 6.5609 16.0824 7.25244 16.2454L12.3755 17.4469C13.067 17.6099 14.0974 17.3967 14.6757 16.9731L17.2125 15.114C17.8776 14.6298 17.9991 14.2385 17.9991 13.5402V10.5099C18 9.79075 17.8831 9.42311 17.2125 8.93607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0464 8.70121V8.86987L13.7209 8.16585C13.5793 8.09099 13.3363 8.0512 13.1791 8.07773L11.6874 8.32883C11.5129 8.3582 11.3713 8.53065 11.3713 8.71542V13.0618C11.3713 13.9525 10.7839 14.1704 10.1362 14.105L9.21354 14.0141C8.50739 13.9421 8.24521 13.4048 8.24521 12.7737V9.24415C8.24521 9.06033 8.10453 8.93525 7.92914 8.96368L7.10605 9.10107C6.93157 9.1295 6.78906 9.3029 6.78906 9.48672V12.9348C6.78906 14.3846 7.68066 15.1805 9.2784 15.4297L10.4349 15.6135C12.1286 15.8769 13.4651 15.0412 13.4651 13.0419V10.0903L15.0473 10.511V12.2365C15.0473 12.4203 15.1898 12.5558 15.3661 12.5397L15.9371 12.4952C16.1134 12.4791 16.2568 12.317 16.2568 12.1323V10.8322L17.089 11.054C17.1913 11.0814 17.2754 11.0151 17.2754 10.9042V10.2523C17.2754 10.1424 17.1986 10.0117 17.1045 9.96144L16.2577 9.51231V9.28774C16.2577 8.39894 15.8713 8.02088 15.6182 7.80105C15.599 7.78399 15.6137 7.76504 15.6338 7.77736C15.6283 7.77357 14.3274 6.82224 14.3293 6.82318C14.3283 6.82318 14.3274 6.82224 14.3265 6.82129C14.7413 7.12545 15.0464 7.69208 15.0464 8.70121Z",
    fill: "#E40080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7476_65335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLg);
export default __webpack_public_path__ + "static/media/unLG.fbfb878bf767afa2ef596273c40b1610.svg";
export { ForwardRef as ReactComponent };